// esta es la pagina de gracias de contacto
import React from "react"
import Layout from "../components/layout"
import Hero from "../components/hero"
import Block from "../components/block90vh"
import Img from "../assets/images/bgHeroGarantia.jpg"
import Data from "../data/asesoriaPostVenta"
// import Formulario from "../components/formularioReporteFalla"
// import ImgGarantia from "../assets/images/garantiaContacto.jpg"
export default function garantiaVentaDeRepuestos() {
  return (
    <>
       <Layout
        img={Img}
        title="Asesoría Post-Venta"
        description="Asesoría Post-Venta de Intramet"
      >
        <Hero img={Img} title="Asesoría Post-Venta"></Hero>
        <Block boton={true} data={Data}></Block>
      </Layout>
    </>
  )
}
